import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Login from '../../containers/login'

class LoginModal extends Component {
  render() {
    return (
      <div className="modal-content">
        <Login
          modal={true}
          setModal={this.props.setModal} />
      </div>
    )
  }
}

LoginModal.propTypes = {
  setModal: PropTypes.func
}

LoginModal.defaultProps = {
  setModal: function() {}
}

export default LoginModal



// WEBPACK FOOTER //
// ./src/components/modals/login-modal.js